module.exports = __webpack_public_path__ + "GitHub-Mark-32px.png?f87561b8bb354ef83b09a66e54f70e08";


//////////////////
// WEBPACK FOOTER
// ./src/assets/GitHub-Mark-32px.png
// module id = 45
// module chunks = 0